import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: `[autoScroll]`
})
export class AutoScrollDirective {
  @Input("autoScroll") elementId: string;

  constructor(public el: ElementRef) {}

  // easing functions http://goo.gl/5HLl8
  easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return (c / 2) * t * t + b;
    }
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  easeInCubic(t, b, c, d) {
    const tc = (t /= d) * t * t;
    return b + c * tc;
  }

  inOutQuintic(t, b, c, d) {
    const ts = (t /= d) * t,
      tc = ts * t;
    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
  }

  requestAnimFrame = (function() {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      function(callback) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })();

  scrollTo(to, callback, duration) {
    // because it's so fucking difficult to detect the scrolling element, just move them all
    function move(amount) {
      document.documentElement.scrollTop = amount;
      document.body.parentElement.scrollTop = amount;
      document.body.scrollTop = amount;
    }
    function position() {
      return (
        document.documentElement.scrollTop ||
        document.body.parentElement.scrollTop ||
        document.body.scrollTop
      );
    }

    const start = position(),
      change = to - start,
      increment = 20;
    let currentTime = 0;

    duration = typeof duration === "undefined" ? 500 : duration;

    const animateScroll = function() {
      // increment the time
      currentTime += increment;
      // find the value with the quadratic in-out easing function
      const val = this.easeInOutQuad(currentTime, start, change, duration);
      // move the document.body
      move(val);
      // do the animation unless its over
      if (currentTime < duration) {
        this.requestAnimFrame(animateScroll);
      } else {
        if (callback && typeof callback === "function") {
          // the animation is done so lets callback
          callback();
        }
      }
    };
    animateScroll();
  }

  @HostListener("mouseenter")
  onMouseEnter() {
    this.highlight("blue");
  }

  @HostListener("mouseleave")
  onMouseLeave() {
    this.highlight("");
  }

  public highlight(color: string) {
    this.el.nativeElement.style.cursor = "pointer";
    this.el.nativeElement.style.color = color;
  }
}
